import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi, type PurchaseOrder } from '../../api/procurement';

export function GoodsReceiptPage() {
  const [pos, setPos] = useState<PurchaseOrder[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void procurementApi.listPOs().then(setPos);
  }, []);

  async function receive(poId: string) {
    await procurementApi.createGRN({
      po_id: poId,
      items: [{ sku: 'SKU-001', received: 100, accepted: 98, damaged: 2 }],
    });
    setMsg('GRN recorded');
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Goods receipt (GRN)</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {pos.map((po) => (
          <li key={po.id}>
            <button type="button" onClick={() => void receive(po.id)}
              className="rounded border px-3 py-2 text-sm">Receive {po.po_number}</button>
          </li>
        ))}
        {!pos.length && <li className="text-sm text-slate-500">Create a PO first</li>}
      </ul>
    </div>
  );
}
